export const sources = {
	webp: "__VITE_ASSET__rUkiH63qcJGEQEedyX41xw__ 500w, __VITE_ASSET__8KByd7W0oH8zGe1MvrBFUw__ 574w"
};
export const img = {
	src: "__VITE_ASSET__8KByd7W0oH8zGe1MvrBFUw__",
	w: 574,
	h: 800
};
export default {
	sources: sources,
	img: img
};
